import {BaseContainerModel} from '../base-container.model';
import {bl_applet_store_hostname_link_RowClass} from '../../dbschema';

export class AppletStoreHostnameContainerModel extends BaseContainerModel {
  bl_applet_store_hostname_link: bl_applet_store_hostname_link_RowClass = new bl_applet_store_hostname_link_RowClass();
}
